<!--
    描述： 造价文件新增 excel选择节点
    时间： 2020/5
    created by zjj
-->
<template>
	<div>
		excel选择节点
	</div>
</template>

<script>
export default {
	name: 'cost-structure-list',
	props: {
	},
	data() {
		return {
		}
	},
	methods: {
	},
	created() {
	},
	computed: {
	}
}
</script>

<style lang="less" scoped>
</style>